/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Dialog, CardContent, Card } from "@mui/material";
import { useSnackbar } from "hooks/useSnackbar";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { GalleryContext } from "./context/gallery-context";
import { ImageDialogTopActions } from "./actions/image-dialog-top-actions";
import { ImageDialogBottomActions } from "./actions/image-dialog-bottom-actions";
import { ImageDialogPreviewPanel } from "./panels/image-dialog-preview-panel";
import { ImageDialogUploadPanel } from "./panels/image-dialog-upload-panel";
import { ImageDialogGalleryPanel } from "./panels/image-dialog-gallery-panel";
import { MODES } from "cms/images/image-selector/image-selector-config";

const ImageSelectDialog = () => {

    const { showSnackbar } = useSnackbar();
    const [images, setImages] = useState();
    const searchFunction = SimpliCityAdminSDK.image.search;
    const scrollableHeight = "480px"; // '450px'

    const imageEditContext = useContext(ImageEditContext);
    const open = imageEditContext?.open;
    const handleClose = imageEditContext?.handleClose;
    const selectedImage = imageEditContext?.selectedImage;
    const setSelectedImage = imageEditContext?.setSelectedImage;
    const mode = imageEditContext?.mode;
    const setMode = imageEditContext?.setMode;

    const onSelectImage = (e, image) => {
        e.stopPropagation();
        setSelectedImage(image);
    };

    const galleryCTX = {
        images,
        setImages,
        searchFunction,
        scrollableHeight,
        onSelectImage,
        selectedImage, // from edit context
        setSelectedImage, // from edit context
        showSnackbar,
        setMode,
    };

    const selectTab = (choice) => {
        switch (choice) {
            case "UPLOAD":
                setMode(MODES.UPLOAD);
                break;
            case "GALLERY":
                setMode(MODES.SELECT);
                break;
        }
    };

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth='lg'
                className='simplicity-image-selector-overlay'
            >
                <GalleryContext.Provider value={galleryCTX}>
                    <Card elevation={0} className='simplicity-image-selector-window'>
                        <CardContent sx={{ flex: "1 0 auto", height: "100%" }}>

                            <div className="base-dialog">
                                <div className="base-dialog-title">
                                    Image Selector
                                </div>

                                <ImageDialogTopActions
                                    selectTab={selectTab}
                                />

                                <div className="simplicity-image-selector-window-content">

                                    <div className="simplicity-image-selector-window-active">

                                        {mode === MODES.UPLOAD &&
                                            <ImageDialogUploadPanel />
                                        }
                                        {mode === MODES.SELECT && (
                                            <ImageDialogGalleryPanel />
                                        )}
                                        {mode === MODES.SELECT_PREVIEW && (
                                            <ImageDialogGalleryPanel />
                                        )}

                                    </div>
                                    {mode === MODES.SELECT_PREVIEW && (
                                        <ImageDialogPreviewPanel />
                                    )}

                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    <ImageDialogBottomActions />

                </GalleryContext.Provider>

            </Dialog>
            
        </Fragment>
    );
};

export { ImageSelectDialog };
